module.exports = __webpack_public_path__ + "img/yellow_pet_confidential.d13c9847.svg";